// extracted by mini-css-extract-plugin
export default {"dd-page-loader":"globalLoader_dd-page-loader__0qFvT","dd-loader":"globalLoader_dd-loader__whxT6"};